module.exports = __webpack_public_path__ + "img/1557614077357924353.acf5c69d.png";